import DesEditTeamMainPanelViewModel from 'viewmodel/DesEditTeamMainPanelViewModel';
import { DesBaseCatalogAcc } from '../utils/des-base-catalog-acc';

export default class DesEditTeamMainPanel extends DesBaseCatalogAcc {
    constructor() {
        super(DesEditTeamMainPanelViewModel);
    }

    get locale() {
        return this.getAttribute('locale') || 'en_US';
    }

    get teamId() {
        return this.getAttribute('teamid') || this.getAttribute('team-id');
    }

    get collaborationspaceid() {
        return this.getAttribute('collaborationspaceid');
    }

    getProps() {
        return {
            collaborationspaceid: this.collaborationspaceid,
            teamid: this.teamId
        };
    }
    static get observedAttributes() {
        return [...DesBaseCatalogAcc.observedAttributes, 'email-template-id', 'email-template-params',
        'teamid', 'team-id', 'collaborationspaceid', 'locale'];
    }

}
if (!window.customElements.get('des-edit-team-main-panel')) {
    window.customElements.define('des-edit-team-main-panel', DesEditTeamMainPanel);
}
